<template lang="html">
    <!-- single field -- all updatable field that we can find in the app -->
    <div class="single-field">
        <div v-if="isEditable" class="edit-mode">
            <div class="input-container" @keydown.esc="cancel">
                <!-- all fields comes from vuetify -->

                <!-- simple text field -->
                <!-- #region - Text field -->
                <v-text-field
                    v-if="['text', 'email', 'number', 'link'].includes(type)"
                    v-model="buffer"
                    :type="type"
                    :hint="localHint"
                    :persistent-hint="localHint != null"
                    :hide-details="localHint == null"
                    :mask="mask"
                    :return-masked-value="true"
                    :disabled="loading"
                    :multi-line="multiline != null"
                    :auto-grow="multiline != null"
                    :rows="rows"
                    :error="error"
                    @keydown.native.enter="validate"
                    @keydown.native.tab="validate"
                    autofocus>
                </v-text-field>
                <!-- #endregion -->

                <!-- date pickers  -->
                <!-- #region - Date picker -->
                <template v-else-if="type == 'date'">
                    <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="showDatePicker"
                        transition="slide-y-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                        >
                            <v-text-field
                                slot="activator"
                                v-model="formatedBuffer"
                                :hint="localHint"
                                :persistent-hint="localHint != null"
                                :hide-details="localHint == null"
                                :disabled="loading"
                                :error="error"
                                readonly
                                autofocus
                                @focus="showDatePicker = true"
                                >
                                <!-- @blur.once="showDatePicker = false" -->
                            </v-text-field>
                            <v-date-picker v-model="buffer" no-title locale="fr-FR" first-day-of-week="1" ref="pickerInMenu" autosave></v-date-picker>
                    </v-menu>
                </template>
                <!-- #endregion -->

                <!-- select one item -->
                <!-- #region - Select -->
                <v-select
                    v-else-if="type == 'select' && !multiple"
                    v-model="buffer"
                    :items="localOptions"
                    :hint="localHint"
                    :persistent-hint="localHint != null"
                    :hide-details="localHint == null"
                    :disabled="loading"
                    :error="error"
                    autocomplete
                    autofocus
                    no-data-text="Aucune donnée..."
                    :item-text="optionText"
                    :item-value="optionValue"
                    @input="validate"
                    ref="field"
                >
                </v-select>


                <!-- #endregion -->

                <!-- select multiples -->
                <!-- #region - Select multiple -->
                <v-select
                    v-else-if="type == 'select' && multiple"
                    class="multiple-select"
                    v-model="buffer"
                    :items="localOptions"
                    :hint="localHint"
                    :persistent-hint="localHint != null"
                    :hide-details="localHint == null"
                    :disabled="loading"
                    :error="error"
                    autocomplete
                    no-data-text="Aucune donnée..."
                    :item-text="optionText"
                    :item-value="optionValue"
                    multiple
                    @keydown.native.tab="validate"
                    ref="field"
                >

                    <template slot="selection" slot-scope="data">
                        <v-chip color="primary" text-color="white" small
                            @input="data.parent.selectItem(data.item)"
                            :selected="data.selected"
                            class="chip--select-multi"
                            :key="JSON.stringify(data.item)"
                        >
                            {{data.item.label}}
                        </v-chip>
                    </template>

                </v-select>


                <!-- #endregion -->

                <!-- tel field -->
                <!-- #region - Tel -->
                <div v-else-if="type == 'tel'" class="tel">
                    <v-select
                        v-model="code"
                        :items="Nationalities"
                        :disabled="loading"
                        :error="error"
                        autocomplete
                        autofocus
                        no-data-text="Aucune donnée..."
                        item-text="code"
                        item-value="code"
                        ref="field"
                    >
                    </v-select>

                    <v-text-field
                        v-model="buffer"
                        :type="type"
                        :hint="localHint"
                        :persistent-hint="localHint != null"
                        :hide-details="localHint == null"
                        :mask="mask"
                        :return-masked-value="true"
                        :prefix="prefix"
                        :disabled="loading"
                        :error="error"
                        @keydown.native.enter="validate"
                        @keydown.native.tab="validate">
                    </v-text-field>
                </div>

                <!-- #endregion -->

                <span v-else class="error--text">Type de champ non pris en charge</span>
            </div>

            <div class="actions">
                <!-- icons to validate or cancel actions -->
                <v-btn icon small @click.stop="cancel">
                    <v-icon color="error">close</v-icon>
                </v-btn>
                <v-btn icon small :loading="loading" @click.stop="validate">
                    <v-icon color="success">check</v-icon>
                </v-btn>
            </div>
        </div>
        <!-- view mode, when fields are not in editable mode -->
        <div v-else class="view-mode" :class="{readonly : readonly}">
            <div class="data">
                <!-- if date -- use moment to format date -->
                <template v-if="type == 'date' && view != null">
                    {{ moment(view).format('L') }}
                    <template v-if="suffix != null">
                        {{ suffix }}
                    </template>
                </template>
                <!-- when text is multiline -->
                <template v-else-if="multiline != null">
                    <span v-html="$options.filters.nl2br(view || '-')"></span>
                </template>
                <!-- multiple options   -->
                <template v-else-if="Array.isArray(view) && view.length >= 1">
                    <template v-for="(v,vi) in view">
                        <template v-if="vi < (3)">
                            <v-chip color="primary" text-color="white" small>{{ v }}</v-chip>
                        </template>
                    </template>
                    <!-- with tooltip when too much options chosen -->
                    <v-tooltip v-model="show" right>
                        <v-chip color="primary" text-color="white" small v-if="view.length > 3" slot="activator">+ {{view.length - 3}}</v-chip>
                        <span>
                            <p v-for="(v,vi) in view" :key="vi" v-if="vi>=3" class="mb-0">{{ v }}</p>
                        </span>
                    </v-tooltip>
                </template>
                <!-- when type link -- create clickable link -->
                <template v-else-if="type == 'link'">
                    <a :href="view" target="_blank" v-if="view && view.includes('http')">
                        <template v-if="view">{{'Ouvrir le lien'}}</template>
                        <template v-else> - </template>
                    </a>
                    <a :href="'http://'+view" target="_blank" v-else>
                        <template v-if="view">{{'Ouvrir le lien'}}</template>
                        <template v-else> </template>
                    </a>
                </template>
                <template v-else-if="special_mask == 'round'">
                    <template v-if="view">
                        {{Math.round(view*100)/100}}
                    </template>
                    <template v-else>
                        '-'
                    </template>
                </template>
                <!-- if field empty -->
                <template v-else>
                    {{ view || '-' }}

                    <template v-if="suffix != null">
                        {{ suffix }}
                    </template>
                </template>
            </div>
            <!-- to edit the field -->
            <v-btn icon small @click="switchMode" @keyup.native.enter="switchMode" class="edit" v-if="!this.readonly && $store.state.auth.user.level >= 60"><v-icon>mode_edit</v-icon></v-btn>
            <!-- hide or show a field during export -->
            <v-btn icon small @click="setExportMode()" v-if="!hide_eye && $store.state.auth.user.level >= 60"><v-icon>{{export_button}}</v-icon></v-btn>
        </div>
    </div>
</template>

<script>
    import moment               from 'moment'
    import { Nationalities }    from '../config/enum/Nationalities'
    import nl2br                from '../filters/nl2br'
    moment.locale('fr')

    export default {
        props: {
            model: {
                required: true
            },
            modelText: {
                required: false
            },
            modelValue: {
                required: false
            },
            type: {
                required: false,
                default: 'text'
            },
            hint: {
                required: false
            },
            options: {
                required: false
            },
            optionText: {
                required: false
            },
            optionValue: {
                required: false
            },
            multiple: {
                required: false,
                default: false
            },
            suffix: {
                required: false
            },
            readonly: {
                required: false,
                default: false
            },
            multiline: {
                required: false
            },
            rows: {
                required: false,
                default: 1
            },
            export_button: {
                required: false,
                default: 'visibility'
            },
            hide_eye: {
                required: false,
                default: false
            },
            special_mask: {
                required: false
            }
        },

        data() {
            return {
                dataLoaded      : false,
                isEditable      : false,
                loading         : false,
                buffer          : null,
                formatedBuffer  : null,
                error           : false,
                localHint       : this.hint || null,
                showDatePicker  : false,
                show            : false,
                code            : null,
                prefix         : '',
                moment,
                Nationalities
            }
        },

        computed: {
            // view datas
            view() {
                if(this.modelText && this.modelText.indexOf('.') > -1) {
                    let path    = this.model
                    // if multiples options chosen
                    if(typeof this.model == 'object' && this.modelText != null) {
                        let parts = this.modelText.split('.')

                        for(var z = 0; z < parts.length; z++) {
                            path = path[parts[z]]

                            if(Array.isArray(path) && parts[(z + 1)] != undefined) {
                                let values = path
                                let labels = ''

                                values.forEach((v, i) =>  {
                                    labels += i > 0 ? ', ' : ''
                                    labels += v[parts[(z + 1)]]
                                })

                                if(this.multiple && labels){
                                    let array = labels.split(',')
                                    return array
                                } else {
                                    return labels
                                }
                            }
                        }
                    }

                    return path

                } else if(this.modelText) {
                    // simple text
                    return this.model[this.modelText]

                } else if(this.type == 'select')  {
                    // simple select
                    let selectedOption = this.$_.find(this.options, o => o[this.optionValue] == this.model)
                    return selectedOption ? selectedOption[this.optionText] : null
                }
                else {
                    // other
                    return this.model
                }
            },

            localOptions() {
                // get the options for selects
                if(typeof this.model == 'object' && this.model != null) {
                    return this.model[this.options]

                } else {
                    return this.options
                }
            },

            mask() {
                // create mask for tel input
                if(this.type == 'tel') {
                    return '+ ## ## ## ## ## ##'

                } else {
                    return ''
                }
            }
        },

        methods: {
            // on click on pen -- to edit a field
            switchMode() {
                if(!this.readonly) {

                    let selected = null

                    // Find value of select list width enum
                    if(this.$_.find(this.options, o => o[this.optionValue] == this.model)) {
                        selected = this.$_.find(this.options, o => o[this.optionValue] == this.model).value
                    }

                    // Put model in buffer
                    if(this.model != null && selected == null && !this.multiple) {
                        // Textfield
                        if(this.modelText == undefined) {
                            this.buffer = this.model
                        }
                        // Select Meta simple
                        else {
                            this.buffer = this.model[this.modelText]
                        }
                    }
                    // Select Enum simple
                    else if(this.model != null && !this.multiple) {
                        this.buffer = selected
                    }
                    // only one field open
                    this.$eventHub.$emit('close_field')

                    this.isEditable = !this.isEditable

                    // Set focus, if type = select
                    if(this.isEditable && this.type == 'select' || this.isEditable && this.type == 'tel') {
                        this.$nextTick(() => this.$refs.field.$refs.input.focus())
                    }
                }
            },
            setExportMode() {
                // when click on eye -- visible or not on export
                if(this.model.is_visible == 1) {
                    this.buffer = 0
                } else {
                    this.buffer = 1
                }
                this.$emit('hide', this.buffer)
            },
            // click on cancel
            cancel() {
                // reinit all
                this.isEditable     = !this.isEditable
                this.buffer         = this.model

                if(typeof this.buffer == 'object' && this.modelValue != null) {
                    this.modelValue.split('.').forEach(item => {
                        this.buffer = this.buffer[item]
                    })
                }

                this.error          = false
                this.localHint      = this.hint || null
                this.showDatePicker = false
                this.loading        = false
            },

            // click on validate
            validate() {

                this.showDatePicker = false

                if(this.buffer == this.model) {
                    this.isEditable = false

                } else if(typeof this.model == 'object' && this.modelValue != null) {
                    let val = this.model

                    this.modelValue.split('.').forEach(item => {
                        val = val[item]
                    })

                    if(this.buffer == val) {
                        this.isEditable = false

                    } else {
                        this.loading        = true
                        this.$emit('validate', this.buffer)
                    }

                } else {
                    this.loading        = true
                    this.$emit('validate', this.buffer)
                }
            },

            setError(msg) {
                this.error      = true
                this.localHint  = msg
                this.loading    = false
            },
        },

        watch: {
            '$store.state.single.data': {
                handler(val) {
                    if(typeof val == 'object') {
                        if(!this.dataLoaded) {
                            this.dataLoaded = true
                            this.buffer     = this.model

                            if(typeof this.buffer == 'object' && this.modelValue != null) {
                                this.modelValue.split('.').forEach(item => {
                                    this.buffer = this.buffer[item]
                                })
                            }

                        }

                        if(this.isEditable && this.loading) {
                            this.isEditable = !this.isEditable
                        }

                        this.loading = false
                    }
                },
                deep: true
            },

            buffer(val) {
                if(this.type == 'date') {
                    this.formatedBuffer = moment(this.buffer).format('L')
                }
            },
            code(val){
                this.buffer = val + ''
            },
            // Date picker set first screen : year
            showDatePicker(val) {
                val && this.$nextTick(() => this.$refs.pickerInMenu.activePicker = 'YEAR')
            },
        },

        created() {
            // only one field open
            this.$eventHub.$on('close_field', () => {
                this.isEditable = false
            })
        }

    }
</script>

<style lang="stylus" scoped>
    @require '../assets/css/variables'

    div.single-field {
        width: 100%

        div.edit-mode {
            display: flex
            justify-content: space-between
            align-items: center
            padding: 0 0.5rem
            transform: translateY(1px)

            div.input-container {
                flex: 1

                div.input-group {
                    padding: 0

                    & >>> input {
                        font-size: 1.5rem !important
                    }

                    & >>> .input-group__selections__comma {
                        font-size: 1.5rem !important
                    }
                }
                div.multiple-select {
                    & >>> .input-group__details {
                        display: none
                    }
                }
            }

            div.actions {
                display: flex

                button {
                    margin: 0
                }
            }
        }

        div.view-mode {
            transition: background ease-out 300ms
            display: flex
            justify-content: space-between
            align-items: center
            min-height: 3rem
            padding: 0 0.5rem
            width: 100%

            div.data {
                width: 70%
                overflow: hidden;
                word-break: break-all;
            }

            .icon {
                transition: all ease-out 300ms
                color: #ABB4D0
                font-size: 1.6rem
            }

            &:not(.readonly) {
                .btn--icon.edit {
                    opacity: 0
                    @media screen and (max-width: 1050px){
                        opacity: 1;
                    }
                }

                &:hover {
                    .btn--icon.edit {
                        opacity: 1
                        color: #abb4d0
                    }
                }
                .btn--icon.edit {
                    &:focus {
                        opacity : 1
                        color: #abb4d0
                    }
                }
            }
        }
        .tel {
            display: flex
            align-items: center
            justify-content: flex-start
            div {
                &:nth-of-type(1) {
                    width: 30%
                    margin-right: 1rem
                    flex: none
                }
                &:nth-of-type(2) {
                    width: 70%
                    flex: none
                }
            }
            & >>> .input-group__details {
                min-height: 0
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/SingleField.vue